import m from './SuggestedPersonalLoanOffers';
export default m;
